import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ShareIcon from '@mui/icons-material/Share';
import LogoutIcon from '@mui/icons-material/Logout';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SettingsIcon from '@mui/icons-material/Settings';
import Badge from '@mui/material/Badge';
import Stack from '@mui/material/Stack';
import AppIndex from './AppIndex';
import { useCallback, useState } from 'react';
import { Outlet, useOutlet, useNavigate } from 'react-router-dom';
import { logOut } from '../utils/firebase';
import Logo from '../images/big_logo.webp'
import Confirmation from './Confirmation';
import CheckUnsavedChanges from './CheckUnsavedChanges';
import Styles from './styles/NavMenu.module.css'
import LaunchIcon from '@mui/icons-material/Launch';

export default function NavMenu(props) {

    const container = undefined;
    const [mobileOpen, setMobileOpen] = useState(false);

    const [preventNavigation, setPreventNavigation] = useState(false);
    const [confirmationRoute, setConfirmationRoute] = useState("");
    const [showConfirmation, setShowConfirmation] = useState(false);

    const navigate = useNavigate()
    const outlet = useOutlet()

    const drawerWidth = 240;

    const handleDrawerToggle = useCallback(() => {
        setMobileOpen(!mobileOpen);
    }, [mobileOpen])

    const navigateMenu = useCallback(to => {
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (windowWidth < 600) {
            handleDrawerToggle()
        }
        navigate(to)
    }, [handleDrawerToggle, navigate])

    const handleNavigation = useCallback(route => {
        if (preventNavigation) {

            setConfirmationRoute(route)
            setShowConfirmation(true)

        } else {
            navigateMenu(route)
        }
    }, [preventNavigation, navigateMenu])

    const closeSession = useCallback(() => {
        logOut()
        navigate('/')
    }, [navigate])

    const drawer = (
        <div>
            <Toolbar>
                <img src={Logo} className={Styles.logo} alt='tookeat logo' onClick={() => handleNavigation('/')} />
            </Toolbar>

            <List>

                <Divider />

                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('')}>
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Inicio" />
                    </ListItemButton>
                </ListItem>

                <Divider />

                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('products')}>
                        <ListItemIcon>
                            <ShoppingCartIcon />
                        </ListItemIcon>
                        <ListItemText primary="Productos" />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('shopdata')}>
                        <ListItemIcon>
                            <ModeEditIcon />
                        </ListItemIcon>
                        <ListItemText primary="Informacion del negocio" />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('menudata')}>
                        <ListItemIcon>
                            <MenuBookIcon />
                        </ListItemIcon>
                        <ListItemText primary="Modificar menu" />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('customize')}>
                        <ListItemIcon>
                            <AutoFixHighIcon />
                        </ListItemIcon>
                        <ListItemText primary="Personalizar" />
                    </ListItemButton>
                </ListItem>

                <Divider />

                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('share')}>
                        <ListItemIcon>
                            <ShareIcon />
                        </ListItemIcon>
                        <ListItemText primary="Compartir" />
                    </ListItemButton>
                </ListItem>

                <Divider />

                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('plans')}>
                        <ListItemIcon>
                            <AutoAwesomeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Planes pagos" />
                    </ListItemButton>
                </ListItem>

                <Divider />

                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('settings')}>
                        <ListItemIcon>
                            <SettingsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Cuenta" />
                    </ListItemButton>
                </ListItem>
            </List>

            <Stack className={Styles.userContainer} justifyContent='center' alignItems='center'>
                <Badge
                    badgeContent={props.userData.plan.type === 'free' ? 'Gratis' : 'PRO'}
                    color={props.userData.plan.type === 'free' ? 'success' : 'error'}
                >
                    <Typography>{props.userAuth.email.length > 20 ? props.userAuth.email.slice(0, 20) + '..' : props.userAuth.email}</Typography>
                </Badge>
            </Stack>
        </div>
    )

    return (
        <>
            <Confirmation
                action={() => { setPreventNavigation(false); navigateMenu(confirmationRoute) }}
                open={showConfirmation}
                setOpen={setShowConfirmation}
                title={"Tienes cambios sin guardar"}
                description={"Si sales ahora perderas todos los cambios sin guardar, para guardarlos cierra este dialogo y luego haz click en el boton 'Guardar'"}
                actionMsg={"Salir"}
                rejectMsg={"Cancelar"}
            />
            <CheckUnsavedChanges unsavedChanges={preventNavigation} />

            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    sx={{
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                        ml: { sm: `${drawerWidth}px` },
                    }}
                >
                    <Toolbar>
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ width: '100%' }}
                        >

                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{ mr: 2, display: { sm: 'none' } }}
                            >
                                <MenuIcon />
                            </IconButton>

                            <Button
                                variant='contained'
                                color='secondary'
                                onClick={
                                    props.userData ? props.userData.menuid ? () => window.open('/' + props.userData.menuid, '_blank') : null : null
                                }
                            >
                                Ver menu &nbsp; <LaunchIcon />
                            </Button>

                            <Button color='error' variant='contained' onClick={closeSession.bind(this)}>
                                Salir &nbsp; <LogoutIcon />
                            </Button>
                        </Stack>
                    </Toolbar>
                </AppBar>
                <Box
                    component="nav"
                    sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                    aria-label="mailbox folders"
                >
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                    >
                        {drawer}
                    </Drawer>

                    <Drawer
                        variant="permanent"
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                        open
                    >
                        {drawer}
                    </Drawer>

                </Box>
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` }, maxWidth: '1000px', margin: 'auto', paddingBottom: '75px' }}
                >
                    <Toolbar />

                    {/* Content goes here */}
                    {
                        outlet ? <Outlet context={[props.userAuth, props.userData, props.userMenu, props.updateUserData, props.updateUserMenu, setPreventNavigation]} />
                            : <AppIndex userMenu={props.userMenu} userData={props.userData} updateUserData={props.updateUserData} />
                    }


                </Box>
            </Box>
        </>
    );
}
